import React from 'react';
import { Badge } from '../../../components/ui/badge';
import UserRole from '../../../types/UserRole';

interface RenderUserRoleProps {
  role: UserRole;
}

const roleChips: Partial<Record<UserRole, { label: string; colour: string }>> =
  {
    SUPER_ADMIN: {
      label: 'Super Admin',
      colour: 'border-role-admin text-role-admin'
    },
    JAPETO_ADMIN: {
      label: 'Admin',
      colour: 'border-role-admin text-role-admin'
    },
    ORGANISATION_ADMIN: {
      label: 'Admin',
      colour: 'border-role-admin text-role-admin'
    },
    READ_WRITE: {
      label: 'Editor',
      colour: 'border-role-editor text-role-editor'
    },
    READ_ONLY: {
      label: 'Viewer',
      colour: 'border-role-viewer/[0.23] text-role-viewer/[0.87]'
    }
  };

function RenderUserRole({
  role
}: RenderUserRoleProps): React.ReactElement | null {
  const chip = roleChips[role];
  if (!chip) return null;

  return (
    <Badge
      variant='outline'
      className={`h-8 rounded-full px-3 text-[0.8125rem] font-normal ${chip.colour}`}
    >
      {chip.label}
    </Badge>
  );
}

export default RenderUserRole;
